<div class="container-fluid">
  <div class="d-flex justify-content-center">
    <div class="modal-content1">
      <div class="modal-body modal-wrapper px-3 px-sm-4">
        <div class="row">
          <div class="col-12 file-div-wrap" [ngClass]="{ 'border-red-dropzone': !data?.importData?.file && data?.importData?.isValid}">
            <button class="file-upload-button">
              <ng-container *ngIf="!data?.importData?.uploadSuccess">
                <app-svg classSvg="file-icon" iconType="document"></app-svg>
                <input title="" type="file" class="mx-auto" id="fileSelect" (change)="upload($event)"/>
                <label for="" class="file-lable1 mt-3">{{ importCompanyVM.lable1 }} </label>
                <label class="file-lable2">{{ importCompanyVM.lable2 }}</label>
              </ng-container>
              <div *ngIf="data?.importData?.uploadSuccess" class="d-flex justify-content-end w-100 ">
                <app-svg iconType="CircleClose" (click)="newImport()"></app-svg>
              </div>
              <ng-container *ngIf="data?.importData?.uploadSuccess" class="success">
                <div class="row">
                  <div class="col-12">
                    <img src="./assets/SVGIcons/uploadesuccess.svg" alt="" />
                  </div>
                </div>
                <label class="sucess mt-3 text-gray">{{ importCompanyVM.lable4 }}</label>
                <div class="col-12" *ngFor="let item of file">
                  <span class="text-light-gray font-12">{{ item.name }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="hideErrordiv">
                <div class="row">
                  <div class="col-12">
                    <img src="./assets/SVGIcons/Erroricon.svg" alt="" />
                  </div>
                  <div class="col-12 mt-3">
                    <p class="text-gray">Error! Please try uploading your files again.</p>
                    <p class="text-decoration-underline mt-3"
                      [ngClass]=" hideErrordiv === true  ? 'text-primary-color'  : 'text-gray' "
                      (click)="showuploadedfile()">
                      Upload file
                    </p>
                  </div>
                  <div></div>
                </div>
              </ng-container>
            </button>
          </div>
          <div class="col-12 ps-0 d-flex p-r-0 m-t-5 
            {{ errorMessageSupported ? 'mb-0' : 'mb-3' }}
            {{ errorMessageSupported ? 'justify-content-between' : 'justify-content-end' }}">
            <div class="d-flex flex-column">
              <div *ngIf="errorMessageSupported" class="text-red font-11">{{headerText}}</div>
            </div>
            <div class="download-svg">
              <a class="d-flex align-items-center hand" [href]="sourcePath" [download]="fileName"
                [ngClass]="hideErrordiv === true ? 'pe-none' : ''">
                <div [ngClass]=" hideErrordiv === true ? 'svgicon' : 'download-svg-icon' ">
                  <app-svg [ngClass]=" hideErrordiv === true ? 'svgicon' : 'download-svg-icon' " iconType="DownloadGreycolor"> </app-svg>
                  <span class="ps-1 download-btn" [ngClass]="!hideErrordiv === true ? 'text-semi-primary' : 'text-light-gray'">Download Sample File</span>
                </div>
              </a>
            </div>
          </div>
          <div class="col-12 px-0 m-b-20">
            <p class="info-text">The system will automatically map matching fields from your spreadsheet.</p> 
            <p class="info-text">Unmapped fields can be assigned manually in the next step.</p> 
          </div>
          <ng-container *ngIf="data?.importConsignment || data?.importOEMExcess || data?.importInventory || data?.importVendorParts">
            <div class="col-12 ps-0 m-b-10 mt-2">
              <span class="text-gray font-15">Assign</span>
            </div>
            <div class="col-12 assign-box px-0">
              <div class="row pt-3 mx-0">
                <div *ngIf="data?.importConsignment" class="col-12 col-sm-6 ps-0">
                  <div class="pb-4">
                    <app-dropdown 
                      [selectLabel]="'Consignor'" 
                      [data]="data?.importData?.consignorList" 
                      [required]="true"
                      [positionStrategy]="'absolute'"
                      [ngClass]="{'border-red': !data?.importData?.consignorId &&  data?.importData?.isValid }"
                      [selectValue]="data?.importData?.consignorId"
                      (selectValueEmit)="data.importData.consignorId = $event;getContactList($event)">
                    </app-dropdown>
                  </div>
                  <div class="pb-4">
                    <app-input
                      [inputLabel]="'Payout Percentage'"
                      [inputType]="'text'"
                      onlyNumbers
                      [inputMaxlength]="10"
                      [inputValue]="data?.importData?.payoutPercentage"
                      (inputValueEmit)="data.importData.payoutPercentage = $event"
                    >
                    </app-input>
                  </div>
                </div>
                <div *ngIf="data?.importOEMExcess" class="col-12 col-sm-6 ps-0">
                  <div class="pb-4">
                    <app-dropdown 
                      [selectLabel]="'Customer'" 
                      [data]="data?.importData?.customerList" 
                      [required]="true"
                      [positionStrategy]="'absolute'"
                      [ngClass]="{'border-red': !data?.importData?.customerId && data?.importData?.isValid }"
                      [selectValue]="data?.importData?.customerId"
                      (selectValueEmit)="data.importData.customerId = $event;getContactList($event)">
                    </app-dropdown>
                  </div>
                </div>
                <div *ngIf="data?.importInventory" class="col-12 col-sm-6 ps-0">
                  <div class="pb-4">
                    <app-dropdown 
                      [selectLabel]="'Company'" 
                      [data]="data?.importData?.companyList" 
                      [required]="true"
                      [positionStrategy]="'absolute'"
                      [ngClass]="{'border-red': !data?.importData?.companyId && data?.importData?.isValid }"
                      [selectValue]="data?.importData?.companyId"
                      (selectValueEmit)="data.importData.companyId = $event;getContactList($event)">
                    </app-dropdown>
                  </div>
                </div>
                <div *ngIf="data?.importVendorParts" class="col-12 col-sm-6 ps-0">
                  <div class="pb-4">
                    <app-dropdown 
                      [selectLabel]="'Vendor'" 
                      [data]="data?.importData?.vendorList" 
                      [required]="true"
                      [positionStrategy]="'absolute'"
                      [ngClass]="{'border-red': !data?.importData?.vendorId && data?.importData?.isValid }"
                      [selectValue]="data?.importData?.vendorId"
                      (selectValueEmit)="data.importData.vendorId = $event;getContactList($event)">
                    </app-dropdown>
                  </div>
                </div>
                <div class="col-12 col-sm-6 ps-0 ps-sm-2 pe-sm-1">
                  <div class="pb-4">
                    <app-dropdown 
                      [selectLabel]="'Contact'" 
                      [data]="data?.importData?.contactList" 
                      [required]="true"
                      [positionStrategy]="'absolute'"
                      [ngClass]="{'border-red': !data?.importData?.contactId && data?.importData?.isValid}"
                      [selectValue]="data?.importData?.contactId"
                      (selectValueEmit)="data.importData.contactId = $event">
                    </app-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="col-12 ps-0 m-b-10 mt-2">
            <span class="text-gray font-15">Mapping Template</span>
          </div>
          <div class="col-12 assign-box px-0">
            <div class="row pt-3 mx-0">
              <div class="col-12 col-sm-6 ps-0">
                <div>
                  <app-custom-select 
                    [options]="data?.importData?.mappingTemplateList"
                    (select)="selectmappingTemplateId($event); showDescription() ; base64OfFile ? checkingValidateFiles():''"
                    (inputValueEmit)="updateList()"
                    [selectLabel]="'Template name'"
                    (selectedLabel)="selectedLabel($event)"
                    [selctedValue]="!data?.importData?.mappingTemplateId ? undefined : data?.importData?.mappingTemplateName"
                  ></app-custom-select>
                </div>
                <div class="mt-1 font-10 text-light-gray text-truncate">
                  <span class="d-inline-block text-truncate"
                    style="max-width: 100%;"
                    [ngbTooltip]="data?.importData?.templateDescription" [tooltipClass]="'custom-tooltip-class'" placement="bottom"
                    container="body">
                    ({{ data?.importData?.templateDescription == "" || data?.importData?.templateDescription == null
                    ? "Template Description shows here"
                    : data?.importData?.templateDescription }})
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>